// extracted by mini-css-extract-plugin
export default {"title":"Texts_title__TDAJI","subtitle":"Texts_subtitle__bKkPa","paragraph":"Texts_paragraph__cTb0W"};